// extracted by mini-css-extract-plugin
export var label = "_bt-5";
export var slideContainer = "_bt-0";
export var slider = "_bt-1";
export var sliderLg = "_bt-4";
export var sliderMd = "_bt-3";
export var sliderSm = "_bt-2";